import { create } from 'zustand';

export const useWorkflowInstanceStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selected: null,
    columnFilters: {},
    uniqueValues: {},

    paginationData: {
        currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 20,
        hasNextPage: false, hasPreviousPage: false,
    },

    searchParams: {
        purpose: '',
        entityType: '',
        status: '',
        templateCode: '',
    },

    setItems: (items) => set({ items }),
    setSelected: (selected) => set({ selected }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (params) => set((state) => ({ searchParams: { ...state.searchParams, ...params } })),
}));
